import { useState, useEffect } from 'react';
import { isLookupReady, normalizeMobile } from '../../shared/phone';
import { customerService } from '../modules/customers/services/customerService';
import type { Customer } from '../types/customer';

export function useDuplicateCustomer(
  mobileValue: string | undefined,
  currentName: string | undefined,
) {
  const [duplicateMatch, setDuplicateMatch] = useState<Customer | null>(null);
  const [dismissedMobile, setDismissedMobile] = useState<string | null>(null);

  useEffect(() => {
    if (!mobileValue) return;
    const normalized = normalizeMobile(mobileValue);
    if (!isLookupReady(mobileValue)) {
      setDuplicateMatch(null);
      return;
    }
    if (dismissedMobile === normalized) return;

    let cancelled = false;
    const timer = setTimeout(async () => {
      try {
        const match = await customerService.findByMobile(mobileValue);
        if (cancelled) return;
        if (match && match.name !== currentName) {
          setDuplicateMatch(match);
        } else {
          setDuplicateMatch(null);
        }
      } catch {
        if (!cancelled) setDuplicateMatch(null);
      }
    }, 400);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [mobileValue, currentName, dismissedMobile]);

  const dismissMatch = () => {
    if (mobileValue) {
      setDismissedMobile(normalizeMobile(mobileValue));
    }
    setDuplicateMatch(null);
  };

  return {
    duplicateMatch,
    dismissMatch,
    clearMatch: () => setDuplicateMatch(null),
  };
}
